// MauritiusCompanyRegistration.jsx
import React from "react";

export default function MauritiusCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Mauritius Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with Mauritius Company Registration for international business structuring.
          </p>
          <p className="text-gray-700">
            Complete IBC/Global Business Company incorporation through Corporate and Business Registration Department including name reservation, MRA approval, company secretary appointment, registered agent setup, and Certificate of Incorporation within 48 hours.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Mauritius offshore business incorporation) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/2387874/pexels-photo-2387874.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Mauritius offshore company registration and business structuring"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless CBRD and FSC approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Passport copies (directors, shareholders, beneficial owners)</li>
                <li>Business activity details (proposed objects and activities)</li>
                <li>Address proof (registered office and management address)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in Mauritius IBC/GBC structuring with OECD-compliant substance requirements and tax treaty network optimization.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Offshore Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Companies Act 2001 and FSC regulations knowledge including economic substance rules, beneficial ownership register, transfer pricing compliance, CRS/FATCA reporting, and 80+ double tax treaty network.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Memorandum and Articles preparation, director/shareholder consents, registered agent agreements, AML/KYC documentation, MRA substance declarations, and CBRD portal submissions ensuring instant approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from name reservation through Certificate of Incorporation, FSC GBC license applications, corporate bank introductions, management office setup, tax residency certification, and ongoing compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
